import { FC, ReactNode, Suspense } from 'react'
import { PropsWithFallback } from '../context-factories/with-suspended-context/suspended-context.types'

const withSuspense = <P extends object>(
  Component: FC<P>,
  fallback?: ReactNode,
) => {
  const SuspendedComponent = (props: PropsWithFallback<P>) => (
    <Suspense fallback={props.fallback ?? fallback}>
      <Component {...props} />
    </Suspense>
  )

  SuspendedComponent.displayName = Component.displayName

  return SuspendedComponent
}

export default withSuspense
